var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5414 3.7574C13.9503 3.04804 13.0045 2.69336 11.9404 2.69336C10.9946 2.69336 10.0488 3.04804 9.33943 3.7574C8.7483 4.34853 8.27539 5.29434 8.27539 6.35838C8.27539 7.3042 8.7483 8.25001 9.33943 8.84114C10.0488 9.5505 10.9946 9.90518 11.9404 9.90518C13.0045 9.90518 13.9503 9.5505 14.5414 8.84114C15.2508 8.25001 15.6054 7.3042 15.6054 6.35838C15.6054 5.29434 15.2508 4.34853 14.5414 3.7574Z",
    fill: "#5981E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6.35796C24 6.35796 11.9409 -7.94745 0 6.35796C11.9409 20.5452 24 6.35796 24 6.35796ZM11.9409 1.51067C13.3596 1.51067 14.5419 1.98358 15.3695 2.92939C16.3153 3.75698 16.7882 4.93924 16.7882 6.35796C16.7882 7.65846 16.3153 8.84072 15.3695 9.78654C14.5419 10.6141 13.3596 11.087 11.9409 11.087C10.6404 11.087 9.45813 10.6141 8.51232 9.78654C7.68473 8.84072 7.0936 7.65846 7.0936 6.35796C7.0936 4.93924 7.68473 3.75698 8.51232 2.92939C9.45813 1.98358 10.6404 1.51067 11.9409 1.51067Z",
    fill: "#5981E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReceipt);
export default __webpack_public_path__ + "static/media/view_receipt.d071bcd87fe3d79e9d507711f57af4d0.svg";
export { ForwardRef as ReactComponent };